import qs from 'qs';
import instance, { PPR_API_URL } from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { ITaskReport } from './interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getTaskReportList = (params: IDynamicTableParams): Promise<ITaskReport[]> => {
  return instance(true, PPR_API_URL)
    .get('/taskReport/list', { params, paramsSerializer: (params) => qs.stringify(params, { allowDots: true }) })
    .then((response) => response.data);
};

export const getTaskReportAvailableColumns = (): Promise<IAvailableColumnModel[]> => {
  return instance(true, PPR_API_URL)
    .get('/taskReport/availableColumns')
    .then((response) => response.data);
};

export const getTaskReportAvailableGroupColumns = (): Promise<IAvailableGroupColumnModel[]> => {
  return instance(true, PPR_API_URL)
    .get('/taskReport/availableGroupColumns')
    .then((response) => response.data);
};
